module.exports = __webpack_public_path__ + "img/hohlsaum_gruen_candy.54d599a5.jpg";